import debug from 'webmd-debug';
/*
 * This code is written in JavaScript and is used for integrating PulsePoint and ID5,
 * Live ramp API in a web application. It checks for certain conditions before executing 
 * the main functionality. It creates a `webmd` object if it doesn't already exist and adds
 * `pulsePoint` function to it. This function is responsible for loading PulsePoint and ID5 scripts,
 *  and fetching user IDs from these services. It also sets up event listeners to pass the fetched IDs to Adobe Analytics when the 'onAdobeOmniBeforePv' event is triggered. The code also includes performance measurements using the `window.performance` API for tracking the time taken for different processes.
 */
export let pulsePointId;
if (typeof window !== 'undefined') {
   window.performance.mark('pp-container-starts');
   var partnerId =  '5488';
   if(window.location.host && window.location.host.indexOf("vitals") > -1){
      partnerId =  '5507';
   }

   // Create webmd object if it doesn't already exist
   window.webmd = window.webmd || {};

   pulsePointId = {
      getCookies: function (name) {
         var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
         if (match && name === "ppid5lr") {
            return (match[2].trim());
         } 
         else if (match){
            return (match[2].trim().toLowerCase());
         }
         else {
            console.log(name + 'cookie not available for pulse point')
            return false;
         }
      },
      // Retrieve s_ecid using alloy("getIdentity")
      getDid: function () {
         const _this = this;
         return new Promise((resolve, reject) => {

            if(window.globalMetrics) {
               // A promise that resolves when the DID is ready
               const didReady = new Promise((resolve, reject) => {
                  const didTimeout = setTimeout(() => {
                     debug("Timeout for DID");
                     reject(new Error("DID timeout"));
                  }, 10000);

                  if (window.biConsumerIsReady) {
                     clearTimeout(didTimeout);
                     resolve();
                  } else {
                     const handler = () => {
                        clearTimeout(didTimeout);
                        resolve();
                     };
                     document.addEventListener('onAdobeOmniInitialized', handler, {once : true});
                  }
               })
               .then(() => alloy("getIdentity"))
               .then((result) => {
                  if (result && result.identity && result.identity.ECID) {
                     resolve(`&did=${result.identity.ECID}`);
                  } else {
                     resolve("&did=null");
                  }
               })
               .catch((error) => {
                  let didId = _this.getCookies('AMCV_16AD4362526701720A490D45%40AdobeOrg');
                  if (didId && didId !== '') {
                     didId = decodeURIComponent(didId).split('|');
                     didId = '&did=' + didId[1];
                  } else {
                     didId = '&did=null';
                     debug("Error retrieving DID:", error);
                     window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-did-missing");
                  }
                  resolve(didId);
               });
            }
            else {
               let didId = _this.getCookies('s_ecid');
               if (didId && didId != '') {
                  didId = decodeURIComponent(didId).split('|');
                  didId = '&did=' + didId[1];
               } else {
                  didId = '&did=null';
               }
               resolve(didId);

            }
         });
     },
      pulsePoint: function () {
         var refr = window.document.referrer || '';
         var tap = '&tapid=null';
         refr = encodeURIComponent(refr);
         var emailHash, location;
         var _this = this;
         var did;
         if (window.location.search.indexOf('pulsepoint=0') === -1 && window.location.search.indexOf('vendor=0') === -1 && ((window.s_sensitive && window.s_sensitive == 'false') || !window.s_sensitive)) {
            Promise.resolve(window.__tcfapiPromise).then(function () {
               location = _this.getCookies('gtinfo');
               if (location) {
                  location = JSON.parse(location);
                  location = location.cntr
               }
               emailHash = _this.getCookies("REG_UUID");
               if (emailHash) {
                  emailHash = '&he2=' + emailHash;
               } else {
                  emailHash = '&he2=null';
               }
               tap = _this.getCookies('TapAd_DID');
               if (tap) {
                  tap = '&tapid=' + tap;
               }
               _this.getDid().then(function(result) {
                  did = result;  
               var pulseScript = document.createElement('script');
               pulseScript.type = 'text/javascript';
               pulseScript.async = true;
               if (window.isCa && window.__uspapi && typeof (window.__uspapi) === 'function') {
                  window.__uspapi('getUSPData', 1, function (uspData, success) {
                     if (uspData.uspString) {
                        pulseScript.src = 'https://bh.contextweb.com/cp?p=' + partnerId  + '&pageurl=' + encodeURIComponent(window.location.href) + '&us_privacy=' + uspData.uspString + did + '&auth_channel=null' + '&topicid=' + window.s_topic + '&epid=null' + '&pvid=' + window.s_pageview_id + emailHash + '&Referrer=' + refr;
                        document.body.appendChild(pulseScript);
                     }
                  });
               } else if (window.countryBlocked && window.__tcfapi && typeof (window.__tcfapi) === 'function') {
                  window.__tcfapi('getTCData', 2, function (tcData, success) {
                     if (tcData.tcString) {
                        pulseScript.src = 'https://bh-eu.contextweb.com/cp?p=' + partnerId + '&pageurl=' + encodeURIComponent(window.location.href) + '&gdpr_consent=' + tcData.tcString + did + '&auth_channel=null' + '&topicid=' + window.s_topic + '&pvid=' + window.s_pageview_id + emailHash + '&Referrer=' + refr;
                        document.body.appendChild(pulseScript);
                     }
                  });
               } else if (location && location == 'usa') {
                  pulseScript.src = 'https://bh.contextweb.com/cp?p=' + partnerId  + '&pageurl=' + encodeURIComponent(window.location.href) + did + '&auth_channel=null' + '&topicid=' + window.s_topic + '&pvid=' + window.s_pageview_id + '&epid=null' + emailHash + '&Referrer=' + refr;
                  document.body.appendChild(pulseScript);
               } else {
                  pulseScript.src = 'https://bh.contextweb.com/cp?p=' + partnerId  + '&pageurl=' + encodeURIComponent(window.location.href) + did + '&auth_channel=null' + '&topicid=' + window.s_topic + '&pvid=' + window.s_pageview_id + emailHash + '&Referrer=' + refr;
                  document.body.appendChild(pulseScript);
               }
               //window.performance.mark('ads-code-load');
               window.performance.mark('pp-container-loaded');
               window.performance.measure('measure-pp-container-loaded', 'ads-code-load', 'pp-container-loaded');
               debug('(Perf-Mark)pulse point container script loaded -> ' + window.performance.getEntriesByName('measure-pp-container-loaded', 'measure')[0].duration);
            });
         });
         }
      },
      getPPID: async function () {
         window.performance.mark('pp-integration-loading');
         window.performance.measure('measure-pp-integration-loading', 'ads-code-load', 'pp-integration-loading');
         debug('(Perf-Mark) pulse point integration id fetching -> ' + window.performance.getEntriesByName('measure-pp-integration-loading', 'measure')[0].duration);
         window.ppcp = window.ppcp || {};
         window.ppcp.cmd = window.ppcp.cmd || [];
         var hlthpp, ramp, id5ID, ids, rampsrc;
         window.ppcp.cmd.push(
            function () {
               try {
                  debug('PulsePoint ID Service callback getting processed');
                  var promise = window.ppcp.getIDService().getIdSyncPromise();
                  promise.then(function (result) {
                     window.performance.mark('pp-integration-loaded');
                     window.performance.measure('measure-pp-integration-loaded', 'ads-code-load', 'pp-integration-loaded');
                     debug('(Perf-Mark) pulse point integration id fetched -> ' + window.performance.getEntriesByName('measure-pp-integration-loaded', 'measure')[0].duration);
                     debug("Resolved Promise from PulsePoint ID Service", result);
                     if (result && result.data) {
                        window.webmd.ppObj = result;
                        let cookieData = pulsePointId.checkExistingIds();
                        let currentTime = new Date().getTime();
                        
                        // checking ID5 availability
                        if (result.data.ids && typeof result.data.ids.id5 !== 'undefined' && result.data.ids.id5 !== null && result.data.ids.id5.userId !== null) {
                           cookieData.data.ids.id5 = result.data.ids.id5;
                           cookieData.timestamps.id5 = currentTime;
                        }else{
                           window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-id5Id-missing");
                        }

                        // checking liveramp availability   
                        if (result.data.ids  && typeof result.data.ids.lr !== 'undefined' && result.data.ids.lr !== null) {
                           cookieData.data.ids.lr = result.data.ids.lr;
                           cookieData.timestamps.lr = currentTime;
                           
                           // if there is a liveramp decryption error, rampid will be passed as '88888'
                           if ((typeof cookieData.data.ids.lr.statusCode !== 'undefined' && 
                              cookieData.data.ids.lr.statusCode === 103) ||
                              (typeof cookieData.data.ids.lr.userId !== 'undefined' && 
                              cookieData.data.ids.lr.userId === null && 
                              typeof cookieData.data.ids.lr.rawId !== 'undefined' && 
                              cookieData.data.ids.lr.rawId !== null)) {
                                 cookieData.data.ids.lr.userId = '88888';
                                 window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-lrId-missing");
                           }
                           // if there is a liveramp timeout error, rampid will be passed as '77777'
                           else if ((typeof cookieData.data.ids.lr.statusCode !== 'undefined' && 
                              (cookieData.data.ids.lr.statusCode === 200 || cookieData.data.ids.lr.statusCode === 102)) ||
                              (typeof cookieData.data.ids.lr.userId !== 'undefined' && 
                              typeof cookieData.data.ids.lr.rawId !== 'undefined' &&
                              cookieData.data.ids.lr.userId === null && 
                              cookieData.data.ids.lr.rawId === null &&
                              cookieData.data.ids.lr.reason &&
                              (cookieData.data.ids.lr.reason.includes('error') || cookieData.data.ids.lr.reason.includes('timeout')))) {
                                 cookieData.data.ids.lr.userId = '77777';
                                 window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-lrId-missing");
                           } 
                           else {
                              // if there is no error, then we have a valid lrId
                           }                   
                        }else{
                           //if liveramp object does not exist, rampid will be passed as '0'
                           if(cookieData.data.ids.lr.userId){
                              cookieData.data.ids.lr.userId = '0';
                           }
                           window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-lrId-missing");
                        }
                        
                        if(result.data.ids){
                           if(result.data.ids.lr && !result.data.ids.lr.userId){
                              //reason would contain error msg ex: timeout expired after 5000 millis
                              let lrReason  = result.data.ids.lr.reason || '';
                              lrReason = lrReason.split(" ").join("-")
                              window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-lr-error-" + lrReason);
                           }
                           if(result.data.ids.id5 && !result.data.ids.id5.userId){
                              let id5reason  = result.data.ids.id5.reason || '';
                              id5reason= id5reason.split(" ").join("-")
                              window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-id5-error-" + id5reason);
                           }
                           
                        }

                       if(result.data.healthPopulations) {
                        cookieData.data.healthpopulations = result.data.healthPopulations;
                       }else{
                        window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-healthpp-missing");
                       }
                     
                       let expirationDate = new Date();
                       expirationDate.setFullYear(expirationDate.getFullYear() + 99);
                       let cookieExpiration = "expires=" + expirationDate.toUTCString();
                       document.cookie = "ppid5lr=" + JSON.stringify(cookieData) + "; " + cookieExpiration + "; path=/";

                        window.webmd.ppObj = window.webmd.ppObj || {};
                        window.webmd.ppObj.data = cookieData.data;

                        hlthpp = window.webmd.ppObj.data.healthpopulations || '';
                        ids = window.webmd.ppObj.data.ids || {};
                        ramp = ids.lr || {};
                        id5ID = ids.id5 || {};
                        rampsrc = ramp && ramp.src !== undefined && ramp.src !== null ? ramp.src : '';
                        ramp = ramp.userId || '';
                        id5ID = id5ID.userId || '';
                        // Passing the lrid, id5 in page target.
                        if (window.webmd.ads) {
                           ['lrid', 'id5'].forEach((key) => {
                              let value = key === 'lrid' ? ramp : id5ID;
                              window.webmd.ads.setPageTarget(key, value || 0);
                           });
                        }

                        document.addEventListener('onAdobeOmniBeforePv', () => {
                           window.webmd.pulsePoint.passParamsToOmniture(ramp,rampsrc,id5ID,hlthpp);
                           window.performance.mark('pp-integration-ids-passed-to-adobe');
                           window.performance.measure('measure-pp-integration-ids-passed-to-adobe', 'ads-code-load', 'pp-integration-ids-passed-to-adobe');
                           debug('(Perf-Mark) pulse point integration id passed to adobe call -> ' + window.performance.getEntriesByName('measure-pp-integration-ids-passed-to-adobe', 'measure')[0].duration);
                        }, { once: true });
                     } else {
                         window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-id5-no-data-recieved");
                        if (window.webmd.ads) {
                           ['lrid', 'id5'].forEach((key) => {
                              window.webmd.ads.setPageTarget(key, 0);
                           });
                        }
                     }
                  }).catch((error) => {
                     debug('Error in PulsePoint ID Service:', error);
                     if (window.webmd.ads) {
                     window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-id5-error-fetching-response");
                     ['lrid', 'id5'].forEach((key) => {
                        window.webmd.ads.setPageTarget(key, 0);
                     });
                  }
                  });
               } catch {
                  if (window.webmd.ads) {
                     window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-pp-id5-lr", "webmd-pp-id5-error-fetching-response");
                     ['lrid', 'id5'].forEach((key) => {
                        window.webmd.ads.setPageTarget(key, 0);
                     });
                  }
               }
            }
         );
      },

      checkExistingIds: function() {
         let idsInCookie = this.getCookies("ppid5lr");
         if (idsInCookie) {
             let cookieData = JSON.parse(idsInCookie);
             // Ensure that both the data.ids and timestamps objects exist
             cookieData.data.ids = cookieData.data.ids || {};
             // Adding timestamps for old cookies
             cookieData.timestamps = cookieData.timestamps || {};
             return cookieData;
         } else {
             // If there is no cookie, initialise the cookie
             // Set default rampid as '99999' in case the promise does not get resolved
             return { data: { ids: { lr: { userId : '99999' } } }, timestamps: {} };
         }
     },
     
      checkDataInCookie: function () {
         let idsInCookie = this.getCookies("ppid5lr");
         if (idsInCookie) {
            let cookieData = JSON.parse(idsInCookie);
            window.webmd.ppObj = window.webmd.ppObj || {};
            window.webmd.ppObj.data = cookieData.data;
            
            document.addEventListener('onAdobeOmniBeforePv', () => {
               let hlthpp, ramp, id5ID, ids, rampsrc;
               if (window.webmd.ppObj && window.webmd.ppObj.data) {
                  hlthpp = window.webmd.ppObj.data.healthpopulations || '';
                  ids = window.webmd.ppObj.data.ids || {};
                  ramp = ids.lr || {};
                  id5ID = ids.id5 || {};
                  rampsrc = ramp && ramp.src !== undefined && ramp.src !== null ? ramp.src : '';
                  ramp = ramp.userId || '0';
                  id5ID = id5ID.userId || '';

                  let currentTime = new Date().getTime();
                  let id5Exists = cookieData.data.ids.id5 && cookieData.data.ids.id5.userId;
                  let lrExists = cookieData.data.ids.lr && cookieData.data.ids.lr.userId && !['77777', '88888', '99999', '0'].includes(cookieData.data.ids.lr.userId);
                  let id5AgeDays = cookieData.timestamps && cookieData.timestamps.id5 ? (currentTime - cookieData.timestamps.id5) / (1000 * 3600 * 24) : Infinity;
                  let lrAgeDays = cookieData.timestamps && cookieData.timestamps.lr ? (currentTime - cookieData.timestamps.lr) / (1000 * 3600 * 24) : Infinity;
                  if (!id5Exists || !lrExists) {
                     debug('One or more IDs missing. Fetching new IDs.');
                     //for race condition where the omniture call happens before the promise gets resolved
                     window.webmd.pulsePoint.setDefaultLiverampPageTarget();
                     window.webmd.pulsePoint.passParamsToOmniture(ramp,rampsrc,id5ID,hlthpp);
                     this.getPPID();
                     return;
                 }

                  if (id5AgeDays > 2 || lrAgeDays > 2) {
                     debug('One or more IDs in cookie are older than 2 days. Fetching new IDs.');
                     //for race condition where the omniture call happens before the promise gets resolved
                     window.webmd.pulsePoint.setDefaultLiverampPageTarget();
                     window.webmd.pulsePoint.passParamsToOmniture(ramp,rampsrc,id5ID,hlthpp);
                     this.getPPID();
                     return;
                 }
                  // Passing the lrid, id5 in page target.
                  if (window.webmd.ads) {
                     ['lrid', 'id5'].forEach((key) => {
                        let value = key === 'lrid' ? ramp : id5ID;
                        window.webmd.ads.setPageTarget(key, value || 0);
                     });
                  }
               }
               window.webmd.pulsePoint.passParamsToOmniture(ramp,rampsrc,id5ID,hlthpp);
               window.performance.mark('pp-integration-ids-passed-to-adobe');
               window.performance.measure('measure-pp-integration-ids-passed-to-adobe', 'ads-code-load', 'pp-integration-ids-passed-to-adobe');
               debug('(Perf-Mark) pulse point integration id passed to adobe call -> ' + window.performance.getEntriesByName('measure-pp-integration-ids-passed-to-adobe', 'measure')[0].duration);
            }, { once: true });
         } else {
            //for race condition where the omniture call happens before the promise gets resolved
            window.webmd.pulsePoint.passDefaultLridToOmniture();
            this.getPPID();
         }
      },

      setDefaultLiverampPageTarget: function(){
         if(window.webmd.ads){
            window.webmd.ads.setPageTarget('lrid', '99999');
         }
      },

      passDefaultLridToOmniture: async function(){
         window.webmd.pulsePoint.setDefaultLiverampPageTarget();
         document.addEventListener('onAdobeOmniBeforePv', () => {
            if (window && window.globalMetrics) {
               window.globalMetrics.setMetric('identity.rampid', '99999');
            } else if(window && window.s_md && window.s_md.contextData) {
               window.s_md.contextData['wb.rampid'] = '99999';
            }
         }, { once: true }); 
      },

      passParamsToOmniture: function(ramp, rampsrc, id5ID, hlthpp) {
         if (window && window.globalMetrics) {
            window.globalMetrics.setMetric('identity.rampid', ramp);
            window.globalMetrics.setMetric('identity.rampsrc', rampsrc);
            window.globalMetrics.setMetric('identity.id5', id5ID);
            window.globalMetrics.setMetric('identity.healthpop', hlthpp.toLocaleString());
         } else if(window && window.s_md && window.s_md.contextData) {
            window.s_md.contextData['wb.rampid'] = ramp;
            window.s_md.contextData['wb.rampsrc'] = rampsrc;
            window.s_md.contextData['wb.id5'] = id5ID;
            window.s_md.contextData['wb.healthpop'] = hlthpp.toLocaleString();
         }
      }
   }

   /**
   * we need to load Neustar Fabrik once __tcfapiPromise is resolved,
   * the Promise is resolved once tcfapi.js is loaded onto the page
   *
   * tcfapi.js is loaded only in EU locations and in other locations the Promise is
   * resolved immediately (handled in IAB stub code - webmd-ccm.js)
   */
   Promise.resolve(window.__tcfapiPromise).then(function () {

      // Disable id5-pp-integration for webmdrx pages
      if (window.location.host.includes('webmdrx')){
         return false;
      }
      
      if (window.globalConfig && window.globalConfig.ads) {
         let vendorConfig = window.globalConfig.ads.vendorConfig;
         if (vendorConfig.pulsepoint && vendorConfig.pulsepoint.disable && vendorConfig.pulsepoint.disable === true) {
            return false;
         } else {
             //if (!window.location.hostname.includes('vitals.') || !window.location.hostname.includes('doctor.')) {
                     window.webmd.pulsePoint = pulsePointId;
                     pulsePointId.pulsePoint();
                     pulsePointId.checkDataInCookie();
             //}

         }
      } else {
          //if (!window.location.hostname.includes('vitals.') || !window.location.hostname.includes('doctor.')) {
                     window.webmd.pulsePoint = pulsePointId;
                     pulsePointId.pulsePoint();
                     pulsePointId.checkDataInCookie();

         // }
      }
   });

};